module.exports = __webpack_public_path__ + "img/todo-list.791567d3.svg";